import {http, onSuccess, onFail} from "./http";

export const clientCertificateGet = (eventPassword) =>
    http.get(`/api/cp/event/${eventPassword}/client/certificate`)
        .then(onSuccess, onFail);

export const clientCertificateUpdate = (eventPassword, data) =>
    http.post(`/api/cp/event/${eventPassword}/client/certificate`, data)
        .then(onSuccess, onFail);


export const clientCertificateSendMail = (eventPassword, email) =>
    http.post(`/api/cp/event/${eventPassword}/client/certificate/send`, email ? {email} : null)
        .then(onSuccess, onFail);


export const certificateGetFields = (eventPassword) =>
    http.get(`/api/cp/event/${eventPassword}/client/certificate/field`)
        .then(onSuccess, onFail);

export const certificateFieldsCreate = (eventPassword, data) =>
    http.post(`/api/cp/event/${eventPassword}/client/certificate/field`, data)
        .then(onSuccess, onFail);

export const certificateFieldsUpdate = (eventPassword, data) =>
    http.put(`/api/cp/event/${eventPassword}/client/certificate/fields`, data)
        .then(onSuccess, onFail);

export const certificateFieldsDelete = (eventPassword, ids) =>
    http.delete(`/api/cp/event/${eventPassword}/client/certificate/fields`, {params: {ids}})
        .then(onSuccess, onFail);


export const certificateGetOwners = (eventPassword) =>
    http.get(`/api/cp/event/${eventPassword}/client/certificate/owners`)
        .then(onSuccess, onFail);

export const certificateGetOwner = (eventPassword, registrationId) =>
    http.get(`/api/cp/event/${eventPassword}/client/certificate/owner/${registrationId}`)
        .then(onSuccess, onFail);

export const certificateUpdateOwner = (eventPassword, registrationId, data) =>
    http.put(`/api/cp/event/${eventPassword}/client/certificate/owner/${registrationId}`, data)
        .then(onSuccess, onFail);
